__webpack_require__.p = "/price-indicator/";